import React, {useEffect, useState} from "react";
import {useSearchParams} from "react-router-dom";
import {captureItemsStripePayment} from "../api/apiClient";
import {useCartContext} from "../contexts/CartContext";
import PaymentConfirmation from "../components/PaymentConfirmation";
import {trackEvent} from "../utils/fbPixel";

const ShopStripeConfirmationPage = () => {
    const [searchParams] = useSearchParams();
    const [paymentStatus, setPaymentStatus] = useState(null); // null, "success", "general_error"
    const {clearCart} = useCartContext();

    useEffect(() => {
        const sessionId = searchParams.get("session_id");

        if (sessionId) {
            const abortController = new AbortController();

            captureItemsStripePayment(sessionId, abortController.signal)
                .then((data) => {
                    if (data === "success") {
                        setPaymentStatus("success");
                        clearCart();
                        trackEvent('Purchase', {currency: 'EUR'});
                    }
                    else {
                        setPaymentStatus("general_error");
                    }
                })
                .catch((error) => {
                    console.error(error);
                    setPaymentStatus("general_error");
                });

            return () => {
                abortController.abort();
            };
        }
    }, [searchParams, clearCart]);

    return (
        <PaymentConfirmation
            paymentStatus={paymentStatus}
            paymentProvider="Stripe"
            backTo="/shop"
            backLabel="ZURÜCK ZUM SHOP"
            generalErrorMessage="Die gewünschten Artikel wurden nicht gekauft."
        />
    );
};

export default ShopStripeConfirmationPage;
